import firebase from 'firebase';

var firebaseConfig = {
    apiKey: "AIzaSyC8vcWmnkl6FfnSLfzHNQTSN_ytnf6ZJtc",
    authDomain: "nvin-in.firebaseapp.com",
    projectId: "nvin-in",
    storageBucket: "nvin-in.appspot.com",
    messagingSenderId: "454251134358",
    appId: "1:454251134358:web:d1ad63e0425b99699cb1b7",
    measurementId: "G-762LE7P57Z"
  };
// Initialize Firebase
firebase.initializeApp(firebaseConfig);

var db = firebase.firestore();


export {db};